import api from "../utils/api-axios"

/**
 * Report API functions
 */
export const reportApi = {
  // Create a new report
  createReport: async (reportData) => {
    try {
      const response = await api.post("/reports", reportData);
      return response;
    } catch (error) {
      console.error("Error creating report:", error);
      throw error;
    }
  },

  // Get user's own reports
  getUserReports: async (page = 1, limit = 10) => {
    try {
      const response = await api.get(`/reports/my-reports?page=${page}&limit=${limit}`);
      return response;
    } catch (error) {
      console.error("Error fetching user reports:", error);
      throw error;
    }
  },

  // Get all reports (Admin only)
  getAllReports: async (filters = {}) => {
    try {
      const { page = 1, limit = 20, type, status, reportedBy } = filters;
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(type && { type }),
        ...(status && { status }),
        ...(reportedBy && { reportedBy })
      });
      
      const response = await api.get(`/reports?${params}`);
      return response;
    } catch (error) {
      console.error("Error fetching reports:", error);
      throw error;
    }
  },

  // Get report by ID (Admin only)
  getReportById: async (reportId) => {
    try {
      const response = await api.get(`/reports/${reportId}`);
      return response;
    } catch (error) {
      console.error("Error fetching report:", error);
      throw error;
    }
  },

  // Update report (Admin only)
  updateReport: async (reportId, updateData) => {
    try {
      const response = await api.put(`/reports/${reportId}`, updateData);
      return response;
    } catch (error) {
      console.error("Error updating report:", error);
      throw error;
    }
  },

  // Get report statistics (Admin only)
  getReportStats: async () => {
    try {
      const response = await api.get("/reports/stats");
      return response;
    } catch (error) {
      console.error("Error fetching report stats:", error);
      throw error;
    }
  }
};

export default reportApi;